define('bindingHandlers/downloadContent',[
    'jquery',
    'lib/lodash4',
    'lib/knockout',
    'lib/bluebird'
], function ($, _, ko, Promise) {
    'use strict';

    /**
     * Creates an iFrame on the body that will accept a download based on the specified content URI.  The Iframe added
     * to accept the download is removed after 10 seconds.  The download will likely still be in progress - the browser
     * will continue the download after the iframe has been removed.
     *
     * @param contentURI - the location of the content to be downloaded
     *
     * or
     *
     * @param function that returns a promise that will resolve to a content URI specifying the transient content URI
     * of a protected asset. The function can either accept the current $data binding as a parameter to define the
     * promise or it should ignore the passed in parameter.
     *
     * or
     * @param options.uri - the location of the content to be downloaded
     * @param options.getUri - a function that will return a promise that will resolve to a content URI specifying the
     * transient content content URI of a protected asset. The function can either accept the current $data binding as a
     * parameter to define the promise or it should ignore the passed in parameter.
     * @param options.removeAfter - number of milliseconds to wait to remove the node added to accept the download.
     *
     * Usage:
     *
     *  <button data-bind="downloadContent: myContentURI">
     *
     *     or
     *
     *  <button data-bind="downloadContent: getContentUri">
     *
     *      or
     *
     *  <button data-bind="downloadContent: { uri         : myContentURI, // optional -- can have string uri or function that returns a promise
     *                                        getUri      : getContentUri, // optional -- can have string uri or function that returns a promise
     *                                        removeAfter : 10000 }">
     *
     * @type {{init: init}}
     */
    ko.bindingHandlers.downloadContent = {
        init: function (element, valueAccessor, bindingData, vm, bindingContext ) {
            var $element = $(element),
                options = valueAccessor(),
                unwrapped = ko.unwrap(options),
                removeAfter = 10000;

            function triggerDownload(){
                var contentLocationPromise = null;

                if (_.has( options, 'uri' ) && _.isString( ko.unwrap( options.uri) ) ){
                    contentLocationPromise = Promise.resolve( ko.unwrap( options.uri ) );
                    removeAfter = unwrapped.removeAfter || 10000;

                } else if ( _.has( options, 'getUri' ) && _.isFunction( options.getUri ) ) {
                    contentLocationPromise = options.getUri( bindingContext.$data );
                    removeAfter = unwrapped.removeAfter || 10000;

                } else  if (_.isString( unwrapped )){
                    contentLocationPromise = Promise.resolve( unwrapped );
                } else if (_.isFunction(options) ){
                    contentLocationPromise = options( bindingContext.$data );
                }

                if ( contentLocationPromise ){
                    contentLocationPromise.then(function(contentLocationURI) {
                        return _.isArray(contentLocationURI) ? contentLocationURI : [contentLocationURI];
                    }).map(function(contentLocationURI) {
                        var id = _.uniqueId('pc-download-content');

                        $('<iframe>', {
                            src: contentLocationURI,
                            id:  id,
                            frameborder: 0,
                            scrolling: 'no',
                            height:0,
                            style:"display:none"
                        }).appendTo($('body'));

                        setTimeout(function(){
                            $('#' + id).remove();
                        }, parseInt( removeAfter, 10 ) );
                    });
                }
            }

            $element.on( 'click', function(){
                triggerDownload();
                return false;
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $element.off('click');
            });
        }
    };
});

